import * as React from 'react';
import { timeStamp, currency } from '~/lib/formatters';
import Table from '~/common/components/Table';
import StyledButton from '~/common/controls/StyledButton';
import { PaycodeStatus } from '../../consts';

export default (props) => {
  const { onView, onReceipt, organizations, transactions, ...rest } = props;

  const handleView = (e, code) => {
    e.preventDefault();
    //onView(code);
  };

  const handleReceipt = (e, code) => {
    e.preventDefault();
    onReceipt(code);
  }

  const columns = [
    {
      Header: 'Date',
      id: 'date',
      accessor: d => timeStamp(d.date),
    },
    {
      Header: 'Code',
      accessor: 'code',
    },
    {
      Header: 'Limit',
      id: 'limit',
      accessor: d => `$` + currency(d.amount),
    },
    {
      Header: 'Status',
      accessor: 'status',
    },
    {
      Header: 'Organization',
      id: 'organization',
      accessor: (d) => {
        return organizations[d.organizationId] && organizations[d.organizationId].name;
      },
    },
    {
      Header: 'Used $',
      id: 'useAmt',
      accessor: (d) => {
        return transactions[d.transactionId] && `$${currency(transactions[d.transactionId].amount)}`;
      },
    },
    {
      Header: 'Use Date',
      id: 'useDate',
      accessor: (d) => {
        return transactions[d.transactionId] && timeStamp(transactions[d.transactionId].processDate);
      },
    },
    {
      Header: 'Note',
      accessor: 'note',
    },
    {
      Cell: (row) => {
        // TODO: Do we need a view functionality here?
        /*
        if (row.original.status === PaycodeStatus.ACTIVE) {
          return (
            <StyledButton onClick={(e) => handleView(e, row.original)} label="View" />
          );
        } else
        */
        if (row.original.status === PaycodeStatus.COMPLETE) {
          const tx = row.original.transactionId ? transactions[row.original.transactionId] : null;

          if (tx && tx.receiptUrl) {
            return (
              <StyledButton onClick={(e) => handleReceipt(e, row.original)} label="Receipt" />
            );
          }
        }

        return null;
      }
    },
  ];

  return (
    <Table
      columns={columns}
      {...rest}
    />
  );
};
